const crystalprime7000 = {
    id: 'crystalprime7000',
    publicSiteName: 'Crystal Prime 7000',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#1239ba',
            secondary: '#121212',
            color1: '#c9d3cd',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: true,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/crystalprime7000/favicon.ico',
        logo: '/crystalprime7000/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default crystalprime7000